'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './guest-edit.routes';

export class PiperGuestEditComponent {
  constructor(Auth, PiperGuestService, $stateParams, $state, dialogs, $uibModal, StorageService) {
    'ngInject';

    this.PiperGuestService = PiperGuestService;
    this.StorageService = StorageService;
    this.Auth = Auth;
    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.guestId = $stateParams.id;

    this.isNewGuest = true;
    this.title = "Create Guest";

    this.guest = {
      isBusiness: false,
      host: Auth.getCurrentUserSync()._id,
      notes: [],
      identityMarkers: [],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    if (this.guestId) {
      this.PiperGuestService.get({id: this.guestId}, data => {
        this.guest = data;
        this.isNewGuest = false;
        this.title = "Edit Guest";

        this.activeTab = (this.guest.isBusiness) ? 1 : 0;
      }, err => {
        console.log('Could not load piper guest from server');
      })
    }
  }

  setBusiness(isBusiness) {
    this.guest.isBusiness = isBusiness;
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: true,
            userId: that.Auth.getCurrentUserSync()._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newPhotos) {

        let data = newPhotos.map(photo => {
          return {
            type: 'photo',
            note: '',
            data: photo._id
          };
        });

        that.guest.identityMarkers = that.guest.identityMarkers.concat(data);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
            that.guest.identityMarkers.push({
              type: 'photo',
              note: '',
              data: storageId
            });
        });

      },
      function () { /* cancel */ }
    );

  }

  removeIdentityMarker(idx) {
    this.guest.identityMarkers.splice(idx,1);
  }

  create(form) {
    var that = this;

    if (this.guest.isBusiness) {
      if (!this.guest.business || this.guest.business.trim() == '') {
        this.dialogs.error("Name the Business", "You must enter a valid name for the business");
        return;
      }
    } else {
      if ( !this.guest.firstName || this.guest.firstName.trim() == ''
         ||!this.guest.lastName || this.guest.lastName.trim() == '') {
        this.dialogs.error("Name your Guest", "You must enter a valid first and last name for your guest");
        return;
      }
    }

    var onSuccess = () => {
      that.submitted = false;

      //TODO: Send cache clear to Gate of Dawn

      var actionString = (that.guestId) ? "changed" : "created";
      var dlg = that.dialogs.notify("Success", "Your guest has been "+actionString+" successfully");
      dlg.result.then(() => {
        that.$state.go("piperGuestList");
      });
    };

    var onError = err => {
      that.sendFailure = true;
    };

    if (this.guestId) {
      this.PiperGuestService.update({id: this.guestId}, this.guest, onSuccess, onError);
    } else {
      this.PiperGuestService.save(this.guest, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.piperGuestEdit', [uiRouter])
  .config(routes)
  .component('piperGuestEdit', {
    template: require('./guest-edit.html'),
    controller: PiperGuestEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/piper/guest/edit/guest-edit.component.js